import { createActionGroup, emptyProps } from '@ngrx/store';

export const deviceActions = createActionGroup({
    source: 'Device',
    events: {
        // The app left the foreground (background / screen-off / power button) — gate the screen.
        Lock: emptyProps(),
        // Same user re-authenticated — resume in place.
        Unlock: emptyProps(),
        // A different user re-authenticated — logout the previous, clean-login the new.
        'Switch User': emptyProps(),
    },
});
